import { useCallback, useRef } from 'react';
import { findNodeHandle, Platform } from 'react-native';
import { useSharedValue } from 'react-native-reanimated';
import { SCROLLABLE_STATE } from '../constants';
export const useScrollable = () => {
  // refs
  const scrollableRef = useRef(null);
  const previousScrollableRef = useRef(null); // variables

  const scrollableState = useSharedValue(SCROLLABLE_STATE.LOCKED);
  const scrollableContentOffsetY = useSharedValue(0); // callbacks

  const setScrollableRef = useCallback(ref => {
    var _scrollableRef$curren, _scrollableRef$curren2;

    // get current node handle id
    let currentRefId = (_scrollableRef$curren = (_scrollableRef$curren2 = scrollableRef.current) === null || _scrollableRef$curren2 === void 0 ? void 0 : _scrollableRef$curren2.id) !== null && _scrollableRef$curren !== void 0 ? _scrollableRef$curren : null;

    if (currentRefId !== ref.id) {
      if (scrollableRef.current) {
        // @ts-ignore
        previousScrollableRef.current = scrollableRef.current;
      } // @ts-ignore


      scrollableRef.current = ref;
    }
  }, []);
  const removeScrollableRef = useCallback(ref => {
    var _scrollableRef$curren3, _scrollableRef$curren4;

    // find node handle id
    let id;

    try {
      id = findNodeHandle(ref.current);
    } catch {
      return;
    } // get current node handle id


    let currentRefId = (_scrollableRef$curren3 = (_scrollableRef$curren4 = scrollableRef.current) === null || _scrollableRef$curren4 === void 0 ? void 0 : _scrollableRef$curren4.id) !== null && _scrollableRef$curren3 !== void 0 ? _scrollableRef$curren3 : null;
    /**
     * @DEV
     * when the incoming node is actually the current node, we reset
     * the current scrollable ref to the previous one.
     */

    if (id === currentRefId) {
      // @ts-ignore
      scrollableRef.current = previousScrollableRef.current;
    }
  }, []);
  const flashScrollableIndicators = useCallback(() => {
    var _scrollableRef$curren5, _scrollableRef$curren6, _scrollableRef$curren7, _scrollableRef$curren8, _scrollableRef$curren9, _scrollableRef$curren10;

    let type = (_scrollableRef$curren5 = (_scrollableRef$curren6 = scrollableRef.current) === null || _scrollableRef$curren6 === void 0 ? void 0 : _scrollableRef$curren6.type) !== null && _scrollableRef$curren5 !== void 0 ? _scrollableRef$curren5 : undefined;
    let node = (_scrollableRef$curren7 = (_scrollableRef$curren8 = scrollableRef.current) === null || _scrollableRef$curren8 === void 0 ? void 0 : _scrollableRef$curren8.node) !== null && _scrollableRef$curren7 !== void 0 ? _scrollableRef$curren7 : undefined;
    let didResize = (_scrollableRef$curren9 = (_scrollableRef$curren10 = scrollableRef.current) === null || _scrollableRef$curren10 === void 0 ? void 0 : _scrollableRef$curren10.didResize) !== null && _scrollableRef$curren9 !== void 0 ? _scrollableRef$curren9 : false;

    if (!type || !node) {
      return;
    } // @ts-ignore


    if (node.current.flashScrollIndicators) {
      // @ts-ignore
      node.current.flashScrollIndicators();
      /**
       * this is a hack to resize the scroll indicator
       * size on iOS.
       */

      if (Platform.OS === 'ios' && !didResize) {
        // @ts-ignore
        node.current.setNativeProps({
          bottom: 0.5
        }); // @ts-ignore

        scrollableRef.current.didResize = true;
      }
    }
  }, []);
  return {
    scrollableRef,
    scrollableState,
    scrollableContentOffsetY,
    setScrollableRef,
    removeScrollableRef,
    flashScrollableIndicators
  };
};
//# sourceMappingURL=useScrollable.js.map